import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import get from 'lodash/get'
import find from 'lodash/find'

import Footer from '@components/footer'
import Header from '@components/header'
import PageHead from '@components/layout/page_head'
import { GlobalContextProvider } from '@util/global_context'
import { SmsForm } from '@components/pages/sms/sms_form'
import { SmsHeader } from '@components/pages/sms/sms_header'
import { SmsInfographic } from '@components/pages/sms/sms_infographic'
import { useLocale } from '@util/useLocale'
import { ViewportProvider } from '@util/viewport'

import styles from '@components/pages/sms/sms_page.module.scss'

const SmsPage = ({ globalContext }) => {
  useLocale(globalContext)

  const { t } = useTranslation()

  const header = find(globalContext.menus, m => get(m, 'fields.name') === 'Header Menu')
  const footer = find(globalContext.menus, m => get(m, 'fields.name') === 'Footer Menu')

  const headerItems = get(header, 'fields.menuItems', [])
  const footerItems = get(footer, 'fields.menuItems', [])

  const showSiteBanner = get(globalContext, 'settings.fields.showSiteBanner', false)
  const siteBanner = get(find(globalContext.siteBanners, ['fields.active', true]), 'fields')

  const page = {
    fields: {
      title: t('sms.headerTitle'),
      metaDescription: {
        metaDescription: t('sms.headerSubtitle'),
      },
      featuredImage: {
        file: {
          url: 'https://images.ctfassets.net/khbu829tujdl/1ZtzJ3S9luKmyGaio2SO8o/beaa93b8c68cade01ebcf4d944fccb3a/Vroom_Facebook_Preview-01.jpg',
        },
      },
    },
  }

  return (
    <ViewportProvider>
      <div className="page__plain">
        <PageHead page={page} globalContext={globalContext} />
        <GlobalContextProvider
          value={{
            ...globalContext,
          }}
        >
          <Header siteBanner={{ showSiteBanner, ...siteBanner }} menuItems={headerItems} />
          <div className={classNames(styles.sms_page__header_section, 'page__plain__bg')}>
            <div className="page__plain__content">
              <SmsHeader />
            </div>
          </div>
          <div className={classNames(styles.sms_page__infographic_form_section, 'page__plain__bg')}>
            <div className="page__plain__content">
              <SmsInfographic />
              <SmsForm />
            </div>
          </div>
          <Footer menuItems={footerItems} />
        </GlobalContextProvider>
      </div>
    </ViewportProvider>
  )
}

export { SmsPage }
